import type { Service } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";

export type ServiceMatch = { id: uuid; parent: uuid | null };

export function servicesByLowercaseName(services: readonly Pick<Service, "id" | "name" | "parent">[]): Map<string, ServiceMatch | null> {
  const map = new Map<string, ServiceMatch | null>();
  for (const service of services) {
    const nameLower = service.name.toLowerCase();
    if (!nameLower) continue;
    map.set(nameLower, map.has(nameLower) ? null : { id: service.id, parent: service.parent?.id ?? null });
  }
  return map;
}
